import { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

const NameDesignModal = ({ isOpen, onClose, onSubmit, onSkip }) => {
  const [designName, setDesignName] = useState('');

  const handleDesignNameChange = (event) => {
    setDesignName(event.target.value);
  };

  const handleSubmit = () => {
    if (designName.trim()) {
      onSubmit(designName.trim());
    }
    setDesignName('');
    onClose();
  };

  const handleSkip = () => {
    setDesignName('');
    onSkip();
    onClose();
  };

  return (
    <Modal
      className='modal-container'
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel='Name Your Design?'
    >
      <h2>Would you like to name your garden design?</h2>
      <div className='modal-input-and-buttons-container'>
        <input
          type='text'
          value={designName}
          onChange={handleDesignNameChange}
          placeholder='i.e. Front Yard 1'
          className='modal-design-name-input'
        />
        <div className='modal-buttons-container'>
          <button onClick={handleSubmit} className='modal-submit-button'>
            Submit
          </button>
          <button onClick={handleSkip} className='modal-skip-button'>
            Skip
          </button>
        </div>
      </div>
    </Modal>
  );
};

NameDesignModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

export default NameDesignModal;
